import { render } from "./RegularTypeInput.vue?vue&type=template&id=34bb51b6&scoped=true"
import script from "./RegularTypeInput.vue?vue&type=script&lang=js"
export * from "./RegularTypeInput.vue?vue&type=script&lang=js"

import "./RegularTypeInput.vue?vue&type=style&index=0&id=34bb51b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34bb51b6"

export default script